import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from './AppUnderTest';

const Register = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    company: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { handleRegister } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!formData.firstName || !formData.lastName || !formData.email || !formData.password) {
      setError('Please fill in all required fields');
      setLoading(false);
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      setLoading(false);
      return;
    }

    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters');
      setLoading(false);
      return;
    }

    try {
      await handleRegister({
        firstName: formData.firstName,
        lastName: formData.lastName,
        name: `${formData.firstName} ${formData.lastName}`,
        email: formData.email,
        company: formData.company,
        password: formData.password
      });
      navigate('/dashboard');
    } catch (err) {
      setError(err.message || 'Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="aut-auth-container">
      <div className="aut-auth-card">
        <div className="aut-auth-header">
          <h1 className="aut-auth-title">Create an account</h1>
          <p className="aut-auth-subtitle">Get started with your free account</p>
        </div>

        {error && (
          <div className="aut-alert aut-alert-error">
            {error}
          </div>
        )}

        <form className="aut-form" onSubmit={onSubmit}>
          <div className="aut-form-row">
            <div className="aut-form-group">
              <label className="aut-label" htmlFor="firstName">First name</label>
              <input
                id="firstName"
                name="firstName"
                type="text"
                className="aut-input"
                placeholder="John"
                value={formData.firstName}
                onChange={handleChange}
              />
            </div>

            <div className="aut-form-group">
              <label className="aut-label" htmlFor="lastName">Last name</label>
              <input
                id="lastName"
                name="lastName"
                type="text"
                className="aut-input"
                placeholder="Doe"
                value={formData.lastName}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="aut-form-group">
            <label className="aut-label" htmlFor="email">Email</label>
            <input
              id="email"
              name="email"
              type="email"
              className="aut-input"
              placeholder="john@example.com"
              value={formData.email}
              onChange={handleChange}
              autoComplete="email"
            />
          </div>

          <div className="aut-form-group">
            <label className="aut-label" htmlFor="company">Company (optional)</label>
            <input
              id="company"
              name="company"
              type="text"
              className="aut-input"
              placeholder="Acme Corp"
              value={formData.company}
              onChange={handleChange}
            />
          </div>

          <div className="aut-form-group">
            <label className="aut-label" htmlFor="password">Password</label>
            <input
              id="password"
              name="password"
              type="password"
              className="aut-input"
              placeholder="Create a password"
              value={formData.password}
              onChange={handleChange}
              autoComplete="new-password"
            />
          </div>

          <div className="aut-form-group">
            <label className="aut-label" htmlFor="confirmPassword">Confirm password</label>
            <input
              id="confirmPassword"
              name="confirmPassword"
              type="password"
              className="aut-input"
              placeholder="Confirm your password"
              value={formData.confirmPassword}
              onChange={handleChange}
              autoComplete="new-password"
            />
          </div>

          <button
            type="submit"
            className="aut-btn aut-btn-primary aut-btn-full"
            disabled={loading}
          >
            {loading ? 'Creating account...' : 'Create account'}
          </button>
        </form>

        <div className="aut-auth-footer">
          Already have an account?{' '}
          <Link to="/login" className="aut-auth-link">
            Sign in
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Register;
